import { render, staticRenderFns } from "./supplement-manage.vue?vue&type=template&id=3cc28e4a&scoped=true"
import script from "./supplement-manage.vue?vue&type=script&lang=ts"
export * from "./supplement-manage.vue?vue&type=script&lang=ts"
import style0 from "./supplement-manage.vue?vue&type=style&index=0&id=3cc28e4a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cc28e4a",
  null
  
)

export default component.exports